import { isNil } from './assert';

export type UnknownObject = Record<string, unknown>;

export const isObject = <T>(obj: T | UnknownObject): obj is UnknownObject =>
  obj !== null && typeof obj === 'object' && !Array.isArray(obj);

export const isObjectAndIsEmpty = <T>(obj: T | UnknownObject): obj is UnknownObject =>
  isObject(obj) && Object.entries(obj).length < 1;

export const isObjectAndIsNotEmpty = <T>(obj: T | UnknownObject): obj is UnknownObject =>
  isObject(obj) && Object.entries(obj).length >= 1;

export const hasProp = <T extends object, K extends string>(
  obj: T,
  key: K,
): obj is T & { [P in K]: unknown } => Object.hasOwn(obj, key);

export const getAllValuesAsString = (input: unknown): string => {
  const result: string[] = [];

  const collect = (value: unknown): void => {
    if (value === null || value === undefined) {
      return;
    } else if (Array.isArray(value)) {
      for (const item of value) {
        collect(item);
      }
    } else if (isObject(value)) {
      for (const key in value) {
        if (Object.prototype.hasOwnProperty.call(value, key)) {
          collect(value[key]);
        }
      }
    } else {
      result.push(String(value));
    }
  };

  collect(input);
  return result.join(' ');
};

export const stringifyWithoutNil = (obj: unknown) => {
  return JSON.stringify(obj, (_key, value) => (isNil(value) ? undefined : value), 1);
};
